<div>
    <app-water-point-svg
        [height]="'35'"
        [lastAssetSample]="lastAssetSample"
        [width]="'35'"
        style="margin: auto"/>
    <div style="position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: var(--main-font-size);
                color: #FFFFFF;
                text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000;">{{ percentage }}
    </div>
    <div style="font-size: var(--main-font-size);
                color: #FFFFFF;
                margin: auto;
                text-align: center;
                justify-content: center;
                text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000;">{{ name }}
    </div>
</div>